'use strict';
import { shop as SHOP_API, order as ORDER_API , otp as OTP_API, careem as CAREEM } from '@teem-app/shop/constants/api';
import Swal from '../teemapp/sweetalert2';
import i18n from  '../teemapp/i18n';
import '@teem-app/shop/app-setting';
const LAST_USER = 'LAST_USER';
const STORAGE_FIELDS = ['email', 'first_name', 'last_name', 'phone_number', 'city_id', 'district_id', 'city_name', 'district_name', 'pickup_date'];
import OtpPinModule from './otp';


let shops = function () {
	$.validator.messages.required = i18n.t('shop.validation.required');

	let selectedCountry = null;
	let selectedDelivery = null;
	let selectedCity = null;
	let selectedDistrict = null;
	let mdlDeliveryForm = null;
	let mdlPickUpForm = null;
	let mdlTrackOrderForm  = null;
	var clicks = 1;
	let selectedOptions = [];
	let productOptions = [];

	let addModifierToCart = function () {
		// Initialize an empty array to hold the selected options
        
		$(document).on('click', '.select-modifier-option', function (event) {
            // Function to update the array on checkbox click
			let checkbox = $(this);
			let option = {
				uuid: checkbox.data('uuid'),
				modifier: checkbox.data('modifier'),
				option: checkbox.data('option')
			};

			// Check if the checkbox is checked
			if (checkbox.is(':checked')) {
				// Add the option to the array if it isn't already in there
				if (!selectedOptions.some(e => (e.option === option.option))) {
					selectedOptions.push(option);
				}
			} else {
				// Remove the option from the array if unchecked
				selectedOptions = selectedOptions.filter(e => (e.option !== option.option));
			}

		})

		$(document).on('click', '.select-product-option', function (event) {
            // Function to update the array on checkbox click
			let checkbox = $(this);
			let option = {
				uuid: checkbox.data('uuid'),
				modifier: checkbox.data('modifier'),
				option: checkbox.data('option')
			};

			$('#updateCart').removeClass('d-none');
			$('#addCart').addClass('d-none');
			// Check if the checkbox is checked
			if (checkbox.is(':checked')) {
				// Add the option to the array if it isn't already in there
				if (!productOptions.some(e => (e.option === option.option))) {
					productOptions.push(option);
				}
			} else {
				// Remove the option from the array if unchecked
				productOptions = productOptions.filter(e => (e.option !== option.option));
			}

		})

		$(document).on('click', '.add-update-to-cart', function (event) {
			// var quantity = $(this).closest('div').next('div').find('.qty_input').val();
			// alert(quantity)
			event.preventDefault();
			let $this = $(this),
			modifierOptions = selectedOptions,
			uuid = $this.attr("data-uuid"),
			type = $this.attr("data-type"),
			shopUuid = $('#storeUuidInput').val(),
			// itemQty = parseInt($(this).closest('div').next('div').find('.qty_input').val())+1;

			// if(isNaN(itemQty)) {
				// itemQty = $this.attr("data-qty") + 1;
			// }
			itemQty = 1;

			$.ajax({
				type: 'POST',
				url: SHOP_API.addItem(shopUuid),
				data: { qty: itemQty, uuid: uuid, type: type, modifierOptions: modifierOptions, productOptions: productOptions},
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.status == true) {
						updateCartItem(resultData.products);
						notify(i18n.t('shop.item_added_to_basket'));
					}
					getCartView(shopUuid);
					// $('.added_'+uuid).removeClass('d-none');
					// $('.add_'+uuid).addClass('d-none');
					// $('.qty_input_'+uuid).val(itemQty);
					addTocartButtonToggle(uuid, resultData.qty);
					updateProductQty(uuid, resultData.qty)
					updateCartProductPrice(uuid,resultData.item_price,resultData.complete_price);
					$('.cart-count').html(resultData.items)
				},
				error: function (jqXHR,error, errorThrown) {
					let jsonValue = jQuery.parseJSON( jqXHR.responseText );
					Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
					if (type == 'product') {
						$(".product-info-close").trigger("click");
					} else {
						$(".service-info-close").trigger("click");
					}
				}
			});
		})
	};

	let addToCart = function () {
		$(document).on('click', '.add-to-cart', function (event) {
			// var quantity = $(this).closest('div').next('div').find('.qty_input').val();
			// alert(quantity)
			event.preventDefault();
			let $this = $(this),
			uuid = $this.attr("data-uuid"),
			type = $this.attr("data-type"),
			shopUuid = $('#storeUuidInput').val(),
			itemQty = 1;//parseInt($(this).closest('div').find('.qty_input').val())+1;

			if(isNaN(itemQty)) {
				itemQty = $this.attr("data-qty") + 1;
			}

			$.ajax({
				type: 'POST',
				url: SHOP_API.addItem(shopUuid),
				data: { qty: itemQty, uuid: uuid, type: type , productOptions: productOptions},
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.status == true) {
						updateCartItem(resultData.products);
						notify(i18n.t('shop.item_added_to_basket'));
					}
					if (window.location.href.includes('cart')) {
						window.location.reload();
					} 
					getCartView(shopUuid);
					// $('.added_'+uuid).removeClass('d-none');
					// $('.add_'+uuid).addClass('d-none');
					// let valData = parseInt($('.qty_input_'+uuid).val()) + 1;
					// $('.qty_input_'+uuid).val(valData);
					addTocartButtonToggle(uuid, resultData.qty);
					updateProductQty(uuid, resultData.qty)
					updateCartProductPrice(uuid,resultData.item_price,resultData.complete_price);
					$('.cart-count').html(resultData.items)
				},
				error: function (jqXHR,error, errorThrown) {
					let jsonValue = jQuery.parseJSON( jqXHR.responseText );
					Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
					if (type == 'product') {
						$(".product-info-close").trigger("click");
					} else {
						$(".service-info-close").trigger("click");
					}
				}
			});
		})

		$(document).on('change', '.qty-input-change', function (event) {
			// var quantity = $(this).closest('div').next('div').find('.qty_input').val();
			// alert(quantity)
			event.preventDefault();
			let $this = $(this),
			uuid = $this.attr("data-uuid"),
			type = $this.attr("data-type"),
			shopUuid = $('#storeUuidInput').val(),
			itemQty = $(this).val();

			if(!isNaN(itemQty)) {
				$.ajax({
					type: 'POST',
					url: SHOP_API.addItem(shopUuid),
					data: { qty: itemQty, uuid: uuid, type: type, from:'qtyInpuy'},
					beforeSend: toggleLoader,
					complete: toggleLoader,
					success: function (resultData) {
						if (resultData.status == true) {
							updateCartItem(resultData.products);
							notify(i18n.t('shop.item_added_to_basket'));
						}
						getCartView(shopUuid);
						// $('.added_'+uuid).removeClass('d-none');
						// $('.add_'+uuid).addClass('d-none');
						// $('.qty_input_'+uuid).val(itemQty);
						addTocartButtonToggle(uuid, resultData.qty);
						updateProductQty(uuid, resultData.qty)
						updateCartProductPrice(uuid,resultData.item_price,resultData.complete_price);
						$('.cart-count').html(resultData.items)
					},
					error: function (jqXHR,error, errorThrown) {
						let jsonValue = jQuery.parseJSON( jqXHR.responseText );
						Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
						if (type == 'product') {
							$(".product-info-close").trigger("click");
						} else {
							$(".service-info-close").trigger("click");
						}
						$this.val(jsonValue.qty)
					}
				});
			}
		})


	};

	let addTocartButtonToggle = (uuid, count) => {
		if (count > 0) {
			$('.added_' + uuid).removeClass('d-none');
			$('.add_' + uuid).addClass('d-none');
		} else {
			$('.added_' + uuid).addClass('d-none');
			$('.add_' + uuid).removeClass('d-none');
		}
	}

	let updateProductQty = (uuid, qty) => {
		$('.qty_input_' + uuid).val(qty);
	}

	let updateCartProductPrice = (uuid,price,completePrice) => {
		$('.item_'+ uuid).html(price);
		$('.complete_price_'+uuid).html(completePrice);
	}

	let getCartView = (shopUuid) =>{
		let collectionChoice = $('#collectionChoice').val();
		if(shopUuid){
			$.ajax({
				type: 'get',
				url: SHOP_API.getCartRoute(shopUuid),
				data:{collection:collectionChoice},
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.status == true) {
						$('.total_order_bar').html(resultData.html);
						$('.mobile_cart_div').html(resultData.mobile);
					}
				},
				error: function (jqXHR,error, errorThrown) {
					let jsonValue = jQuery.parseJSON( jqXHR.responseText );
					Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
					// location.reload();
				}
			});
		}
	}

	getCartView($('#storeUuidInput').val());
	
	let viewProductDetails = function () {
		$(document).on('click', '.product-detials', function (event) {
			let productUuid = $(this).attr('data-product-uuid');
			let productDetails = $('#product-details');
			if (!isEmpty(productUuid) && clicks == 1) {
				clicks++;
				$.ajax({
					type: 'GET',
					url: SHOP_API.getProductDetails(productUuid),
					data: { type: 'html' },
					success: function (resultData) {
						if (resultData.status == true) {
							productDetails.html(resultData.html);
							// productDetails.toggleClass('open');
							// $('#openModal').modal('show');
						}
						setTimeout(function() { clicks = 1; }, 100);

						$('.select-modifier-option:checked').each(function() {
							let checkbox = $(this);				
							let option = {
								uuid: checkbox.data('uuid'),
								modifier: checkbox.data('modifier'),
								option: checkbox.data('option')
							};
				
							if (!selectedOptions.some(e => (e.option === option.option))) {
								selectedOptions.push(option);
							}
						});

						$('.select-product-option:checked').each(function() {
							let checkbox = $(this);				
							let option = {
								uuid: checkbox.data('uuid'),
								modifier: checkbox.data('modifier'),
								option: checkbox.data('option')
							};
				
							if (!productOptions.some(e => (e.option === option.option))) {
								productOptions.push(option);
							}
						});
					}
				});
			}

		})

		$(document).on('click', '.product-info-close', function (event) {
			let productDetails = $('#product-details');
			productDetails.html('');
			// productDetails.toggleClass('open');
			// $('#openModal').modal('hide');
			// $('.modal').modal('hide');
		})
	}

	let viewServiceDetails = function () {
		$(document).on('click', '.service-detials', function (event) {
			let serviceUuid = $(this).attr('data-service-uuid');
			let serviceDetails = $('#service-details');
			if (!isEmpty(serviceUuid) && clicks == 1) {
				clicks++;
				$.ajax({
					type: 'GET',
					url: SHOP_API.getServiceDetails(serviceUuid),
					data: { type: 'html' },
					success: function (resultData) {
						if (resultData.status == true) {
							serviceDetails.html(resultData.html);
							// serviceDetails.toggleClass('open');
							// $('#openModal').modal('show');
						}
						setTimeout(function() { clicks = 1; }, 100);
					}
				});
			}
		})

		$(document).on('click', '.service-info-close', function (event) {
			let serviceDetails = $('#service-details');
			serviceDetails.html('');
			// serviceDetails.toggleClass('open');
			// $('#openModal').modal('hide');
			// $('.modal').modal('hide');
		})
	}

	let viewCart = function () {
		$(document).on('click', '#showCard', function (event) {
			let shopUuid = $(this).attr('data-shop-uuid');
			let $myCart = $('#myCartDetails');
			if (!isEmpty(shopUuid)) {
				$.ajax({
					type: 'GET',
					url: SHOP_API.getCart(shopUuid),
					data: { type: 'html' },
					success: function (resultData) {
						if (resultData.status == true) {
							$myCart.html(resultData.html);
							$myCart.addClass('open');
							$('#productList').addClass('d-none');
							// updateCartItem(resultData.products);
						}
					}
				});
			}

		})
	}

	let updateCartCount = function () {
		$.ajax({
			type: 'GET',
			url: GET_CART_DATA,
			success: function (resultData) {
				updateCartItem(resultData.products);
			}
		});
	}

	let removeCart = function () {
		$(document).on('click', '.remove-from-cart', function (event) {
			event.preventDefault();
			let $this = $(this),
			itemUuid = $this.attr("data-uuid"),
			storeUuid = $('#storeUuidInput').val(),
			itemQty = parseInt($this.parent().find('input.qty_input').val());
			if (itemQty > 0) {
				$.ajax({
					type: 'DELETE',
					url: SHOP_API.deleteItem(storeUuid, itemUuid),
					dataType: "json",
					beforeSend: toggleLoader,
					complete: toggleLoader,
					success: function (resultData) {
						if (resultData.status == true) {
							// var $input = $this.parent().find('input.qty_input');
							// $input.val(parseInt($input.val()) - 1);
							// $input.change();
							updateCartItem(resultData.products);
							notify(i18n.t('shop.item_removed_from_basket'), 'error');
						}
						if (window.location.href.includes('cart')) {
							window.location.reload();
						} 
						getCartView(storeUuid);
						if (itemQty == 1) {
							updateProductQty(itemUuid, 0)
							addTocartButtonToggle(itemUuid, 0);
							updateCartProductPrice(itemUuid,resultData.item_price,resultData.complete_price);
						} else {
							updateProductQty(itemUuid, itemQty - 1)
							updateCartProductPrice(itemUuid,resultData.item_price,resultData.complete_price);
						}
						$('.cart-count').html(resultData.items)
					}
				});
			}
		})
	}

	let removeProduct = function () {
		$(document).on('click', '.remove-product', function (event) {
			event.preventDefault();
			let $this = $(this),
			itemUuid = $this.attr("data-uuid"),
			storeUuid = $('#storeUuidInput').val();
			$.ajax({
				type: 'DELETE',
				url: SHOP_API.deleteItemFromCart(storeUuid, itemUuid),
				dataType: "json",
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.status == true) {
						updateCartItem(resultData.products);
						notify(i18n.t('shop.item_removed_from_basket'), 'error');
					}
					if (window.location.href.includes('cart')) {
						window.location.reload();
					} 
					
					$('.cart-count').html(resultData.items)
					getCartView(storeUuid);
					addTocartButtonToggle(itemUuid, 0);
					updateProductQty(itemUuid, 0)
					updateCartProductPrice(itemUuid,resultData.item_price,resultData.complete_price);
				}
			});
		})
	}

	let validateDeliveryTime = function () {
		$(document).on('change', '#selectDeliveryDate', function (event) {
			event.preventDefault();
			$(".scheduleDeliveryTimimgText").html('');
			let $this = $(this),
			date = $this.val(),
			storeUuid = $('#storeUuidInput').val();

			$.ajax({
				type: 'POST',
				url: SHOP_API.validateDeliveryTime(storeUuid),
				data: { date: date },
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.available == true) {
						$("#selectDeliveryTime").removeAttr("readonly");
						// $("#selectDeliveryTime").attr("min", resultData?.timing?.opening_time);
                		// $("#selectDeliveryTime").attr("max", resultData?.timing?.closing_time);
						$(".scheduleDeliveryTimimgText").html(resultData?.message);
					} else {
						$('#selectDeliveryTime').val('');
						$("#selectDeliveryTime").removeAttr("min");
						$("#selectDeliveryTime").removeAttr("max");
						$("#selectDeliveryTime").attr("readonly", true);
					}
				},
				error: function (jqXHR,error, errorThrown) {
					$('#selectDeliveryDate').val('');
					$('#selectDeliveryTime').val('');
					$("#selectDeliveryTime").removeAttr("min");
					$("#selectDeliveryTime").removeAttr("max");
					$("#selectDeliveryTime").attr("readonly", true);
					let jsonValue = jQuery.parseJSON( jqXHR.responseText );
					Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
				}
			});
		})
	};

	let updateCartItem = function (number) {
		if (number > 0) {
			if ($('#showCard').find('.qty-num').length) {
				$('#showCard').find('.qty-num').text(number);
			} else {
				$('#showCard').append('<div class="store-header__badge" ><span class="qty-num">' + number + '</span></div>');
			}
		} else {
			$('#showCard').find('.store-header__badge').remove();
		}
	}

	let hideShowMyCart = function () {
		$(document).on('click', "#mycart-trigger", function (e) {
			$('#myCartDetails').removeClass('open');
			$('#productList').show().removeClass('d-none');
		});
	}

	let openShoppingModal = function () {
		// populateForm(LAST_USER, $("#pickUpForm"));
		$(document).on('click', "#shopping-modal", function (e) {
			e.preventDefault();
			// $('#pickUpForm').trigger("reset");
			// $('#deliveryForm').trigger("reset");
			// $("#pickUpForm").validate().resetForm();
			// $("#deliveryForm").validate().resetForm();
			$('#shoppingmodal').modal('toggle');


			populateForm(LAST_USER, $("#pickUpForm"));
			populateForm(LAST_USER, $("#deliveryForm"));
		});
	}

	let openOtpPinModal = function (e) {
		let countryCode = $('#countryCode').val();
		let phone = $('#phone-number').val();
		let storeUuid = $('#storeUuidInput').val();
		let firstName = $('#first_name').val();
		let lastName = $('#last_name').val();
		let email = $('#email').val();
		if (phone) {
			$.ajax({
				type: 'POST',
				url: OTP_API.sendOtpPin,
				data: { phone: phone, store_uuid: storeUuid, first_name: firstName, last_name: lastName, email: email },
				beforeSend: toggleLoader,
				complete: toggleLoader,
				success: function (resultData) {
					if (resultData.status == true) {
						notify(resultData.message);
						$('#phone-number-span').text(countryCode + ' ' + phone);
						$('#otp-pin-code').modal('show');
					}
				},
				error: function (jqXHR,error, errorThrown) {
					let jsonValue = jQuery.parseJSON( jqXHR.responseText );
					Swal.fire({title: i18n.t('shop.error'),text: jsonValue.message,icon: 'error'});
				}
			});
		}

		// $('#phone-number-span').text('+966 ' + phone);
		// $('#otp-pin-code').modal('show');
	}

	let openThankYouModal = function (e) {
		$('#thank-you-modal').modal('show');
	}

	$('#sub').submit(function() {
		var validator = $("#deliveryForm").validate()
	})

	$.validator.addMethod("noSpecialChars", function(value, element) {
        return this.optional(element) || /^^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$/.test(value);
    }, "Invalid");

	let deliveryFormValidator = function () {
		mdlDeliveryForm = $("#deliveryForm").validate({
			ignore: 'input[type=hidden], .select2-input, .select2-focusser',
			rules: {
				first_name: { required: true, noSpecialChars: true },
				last_name: { required: true, noSpecialChars: true },
				// city_id: { required: true },
				// district_id: { required: true },
				email: { required: true, email: true },
				phone_number: {
					required: true,
					minlength: 5,
					maxlength: 10,
					number: true
				},
				// area: { noSpecialChars: true },
				// street: { noSpecialChars: true },
				// building_name: { noSpecialChars: true },
			},
			// Specify validation error messages
			messages: {
				first_name: { required : i18n.t("shop.validation.first_name")},
				last_name: { required : i18n.t("shop.validation.last_name")},
				email: i18n.t("shop.validation.email"),
				city_id: i18n.t("shop.validation.city"),
				district_id: i18n.t("shop.validation.district"),
				phone_number: {
					required: i18n.t("shop.validation.phone"),
					minlength: i18n.t("shop.validation.phone_valid"),
					maxlength: i18n.t("shop.validation.phone_valid"),
					number: i18n.t("shop.validation.phone_valid")
				},
			},
			// Make sure the form is submitted to the destination defined
			// in the "action" attribute of the form when valid
			submitHandler: function (form) {
				let localData = getFormData(form);
				// localData.city_name = selectedCity.text;
				// localData.district_name = selectedDistrict.text;
				openOtpPinModal()
				// if (setToStorage(LAST_USER, localData)) {
				// 	form.submit();
				// }
			}
		});
	}

	let cartFormValidator = function () {
		$("#cartForm").validate({
			submitHandler: function (form) {
				form.submit();
			}
		});
	}

	let cartProductFormValidator = function () {
		
		function convertTo12HourFormat(time) {
			let [hours, minutes] = time.split(":");
			let period = hours >= 12 ? "PM" : "AM";
			hours = (hours % 12) || 12; // Convert 0 to 12 for 12 AM
			return `${hours}:${minutes} ${period}`;
		}

		$("#cartProductForm").validate({			
			errorPlacement: function (error, element) {
				if (element.hasClass("time-input") && element.attr("min") && element.attr("max")) {
					let minTime = convertTo12HourFormat($("#selectDeliveryTime").attr("min"));
					let maxTime = convertTo12HourFormat($("#selectDeliveryTime").attr("max"));
					$(element).siblings('.field-error').text("Please select a time between " + minTime + " and " + maxTime);
				} else {
					$(element).closest('fieldset').find('.field-error').text(error.text());
				}
			},
			submitHandler: function (form) {
				// $('#store-collection-type-modal').modal('show');
				// $('#submit-collection-type').on("click", function (e) {
					form.submit();
				// });
			}
		});
	}

	let pickupFormValidator = function () {
		mdlPickUpForm = $("#pickUpForm").validate({
			// Specify validation rules
			rules: {
				pickup_date: "required",
				first_name: { required: true, noSpecialChars: true },
				last_name: { required: true, noSpecialChars: true },
				// information_0: "required",
				email: {
					// required: true,
					email: true
				},
				phone_number: {
					required: true,
					minlength: 5,
					maxlength: 10,
					number: true
				}
			},
			// Specify validation error messages
			messages: {
				pickup_date: i18n.t('shop.validation.pickup_date'),
				first_name: { required : i18n.t("shop.validation.first_name")},
				last_name: { required : i18n.t("shop.validation.last_name")},
				email: i18n.t("shop.validation.email"),
				city_id: i18n.t("shop.validation.city"),
				district_id: i18n.t("shop.validation.district"),
				phone_number: {
					required: i18n.t("shop.validation.phone"),
					minlength: i18n.t("shop.validation.phone_valid"),
					maxlength: i18n.t("shop.validation.phone_valid"),
					number: i18n.t("shop.validation.phone_valid")
				}
			},
			// Make sure the form is submitted to the destination defined
			// in the "action" attribute of the form when valid
			submitHandler: function (form) {
				let localData = getFormData(form);
				openOtpPinModal()
				// if (setToStorage(LAST_USER, localData)) {
				// 	form.submit();
				// }
			}
		});
	}

	let trackOrderFormValidator = function () {
		mdlTrackOrderForm = $("#track-order").validate({
			// Specify validation rules
			rules: {
				order_number: "required",
			},
			// Specify validation error messages
			messages: {
				order_number: "Please enter order number",
			},
			submitHandler: function (form) {
				form.submit();
			}
		});
	}

	let getDistrict = function () {
		$(document).on('change', "#select2City", function (e) {
			e.preventDefault();
			let cityId = $(this).val();

			$("#select2District").val('').trigger('change')

			$('#select2District').select2({
				placeholder: i18n.t("shop.select_district"),
				ajax: {
					url: SHOP_API.getDistrict,
					data: function (params) {
						var query = {
							city_id: cityId,
							q: params.term,
							type: 'public'
						}
						// Query parameters will be ?search=[term]&type=public
						return query;
					},
					processResults: formatSelect2Data,
					cache: true
				}
			}).on('select2:select', (event) => {
				selectedDistrict = event.params.data;
			});

			let deliveryCost = 0;
			if (cityId == $('#store_city').val()) {
				deliveryCost = parseFloat($('#same_city_delivery_cost').val());
			} else {
				deliveryCost = parseFloat($('#inside_ksa_delivery_cost').val());
			}

			if($("#select2Delivery").length > 0) {
				$('.delivery-company, .delivery-price, .delivery-time-div').addClass('d-none');
				let storeUuid = $('#storeUuidInput').val();
				let cityName = $('#city').val();
				$("#select2Delivery").val('').trigger('change')
				$('#select2Delivery').select2({
					placeholder: 'Select delivery',
					ajax: {
						url: SHOP_API.checkOTODeliveryFee,
						beforeSend: toggleLoader,
						complete: toggleLoader,
						data: function (params) {
							var query = {
								store_uuid: storeUuid,
								city_id: cityId,
								city_name: cityName,
								q: params.term,
								type: 'public'
							}
							// Query parameters will be ?search=[term]&type=public
							return query;
						},
						processResults: formatSelect2DelliveryData,
						cache: true
					}
				}).on('select2:select', (event) => {
					selectedDelivery = event.params.data;
					let name = selectedDelivery.name;
					let price = 'SAR '+selectedDelivery.price;
					let deliveryTime = selectedDelivery.delivery_time;
					$('.delivery-company, .delivery-price, .delivery-time-div').removeClass('d-none');
					$('.delivery-company-name').text(name);
					$('.delivery-time').text(addSpacesToString(deliveryTime));
					$('.delivery-price-cost').text(price);
					$('#delivery-option-response').text(JSON.stringify(selectedDelivery));
					deliveryCost = selectedDelivery.price;
				});
			}

			$('#shipping_cost').text(deliveryCost.toFixed(2));
			$('#final_total_amount').text((deliveryCost + parseFloat($('#total_amount').val())).toFixed(2));

		});
	}

	let select2Init = function () {
		$("#select2City").select2({
			'minimumInputLength': 3,
			language: {
				inputTooShort: function (args) {
					return i18n.t("shop.type_city_name")
				}
			},
			ajax: {
				url: SHOP_API.getCities,
				type: "GET",
				dataType: 'json',
				delay: 250,
				data: function (params) {
					return {
						q: params.term // search term
					};
				},
				processResults: formatSelect2Data,
				cache: true
			}
		}).on('select2:select', (event) => {
			selectedCity = event.params.data;
		});

		$('#select2District').select2();
		$('#select2Delivery').select2();
	}

	let select2CountryInit = function () {
		$("#select2Country").select2({
			'minimumInputLength': 3,
			language: {
				inputTooShort: function (args) {
					return i18n.t("shop.type_here")
				}
			},
			ajax: {
				url: SHOP_API.getCountries,
				type: "GET",
				dataType: 'json',
				delay: 250,
				data: function (params) {
					return {
						q: params.term // search term
					};
				},
				processResults: formatSelect2Data,
				cache: true
			}
		}).on('select2:select', (event) => {
			selectedCountry = event.params.data;
			let isoCode = 'fi-'+(selectedCountry.iso_code).toLowerCase();
			let callingCode = '+'+selectedCountry.calling_code;
			$(".order-information__flagIcon span").removeClass().addClass(['fi', isoCode]);
			$("#countryCode").val(callingCode);
			$("#isoCode").val(selectedCountry.iso_code);
			$("#google-address").val('');
			$("#pin_drop_location").val('');
			$("#city").val('');
			$("#select2City").val('').trigger('change');
			$("#select2District").val('').trigger('change');
			$('.within-ksa').addClass('d-none');
			$('.without-ksa').removeClass('d-none');
			$("#city").attr("required", "true");
			$('#select2City').removeAttr('required');
			$('#select2District').removeAttr('required');
			if (selectedCountry.id == 682) {
				$('.without-ksa').addClass('d-none');
				$('#city').removeAttr('required');
				$('.within-ksa').removeClass('d-none');
				$("#select2City").attr("required", "true");
				$("#select2District").attr("required", "true");
			}
			$('#delivery_via').val('fixed_cost');
			$('.otoDelivery').addClass('d-none');
			$('.careemDelivery').addClass('d-none');
			initMap();
		});
	}

	let formatSelect2Data = function (response) {
		return {
			results: $.map(response, function (item) {
				return {
					text: item.name,
					name: item.name,
					id: item.id,
					iso_code: item.iso_3166_2??'',
					calling_code: item.calling_code??''
				}
			})
		};
	}

	let formatSelect2DelliveryData = function (response) {
		return {
			results: $.map(response, function (item) {
				return {
					name: item.deliveryOptionName,
					text: item.deliveryOptionName,
					id: item.deliveryOptionId,
					delivery_time: item.avgDeliveryTime??'',
					price: item.price??''
				}
			})
		};
	}

	let showShopDetails = function () {
		$('.logo-area').on('click', function () {
			$('#shop-detail').toggleClass('d-none');
		})
	}

	function addSpacesToString(input) {
		// Step 1: Add spaces around numbers
		let result = input.replace(/(\d+)([a-zA-Z])/g, '$1 $2'); // Space after numbers
		result = result.replace(/([a-zA-Z])(\d+)/g, '$1 $2'); // Space before numbers
	
		// Step 2: Add space between letters and numbers
		result = result.replace(/([a-z])([A-Z])/g, '$1 $2'); // Space between lowercase and uppercase letters
		
		return result.trim(); // Remove extra leading or trailing spaces
	}

	/**
	 * This function gets the values in the form
	 * and returns them as an object with the
	 * [formIdentifier] as the object key
	 * @returns {Object}
	 */
	let getFormData = (form) => {
		let data = {}; // create an empty object with the formIdentifier as the key and an empty object as its value
		for (const element of $(form).serializeArray()) {
			if (element.name.length > 0 && (jQuery.inArray(element.name, STORAGE_FIELDS) != -1)) {
				data[element.name] = element.value;
			}
		}
		return data;
	};

	let setToStorage = function (formIdentifier, formData) {
		try {
			localStorage.setItem(formIdentifier, JSON.stringify(formData))
			if (localStorage.key(formIdentifier)) {
				return true
			}
		} catch (error) {
		}
		return false;
	}


	/**
	 * This function populates the form
	 * with data from localStorage
	 *
	 */
	let populateForm = (formIdentifier, formObject) => {

		if (localStorage.key(formIdentifier)) {
			const savedData = JSON.parse(localStorage.getItem(formIdentifier)); // get and parse the saved data from localStorage
			if (typeof formObject !== 'undefined' && savedData != null) {
				for (const element of formObject[0].elements) {
					if (element.name in savedData) {


						if (element.type == 'select-one') {
							if(element.name == 'city_id') {
								$(element).select2("trigger", 'select', {
									data: {'id':savedData['city_id'], 'text': savedData['city_name'] }
								});
							} else if(element.name == 'district_id') {

								$(element).select2("trigger", "select", {
									data: {'id':savedData['district_id'], 'text': savedData['district_name'] }
								});
							}
						}
						else {
							$(element).attr('value', savedData[element.name]);
							element.value = savedData[element.name];
						}
					}
				}
			}
		}
	};

	let otpModule = function() {
		OtpPinModule.init();
	}

	let applyPromocode = function () {
		// // Initialize jQuery Validation on the promoCode field
		// $("#promocode").rules("add", {
		// 	required: true,
		// 	messages: {
		// 		required: "Please enter a promo code."
		// 	}
		// });

		// Manually trigger validation on button click
		$("#apply-promocode").click(function (e) {
			$('.promocode-fieldset').removeClass('has-error');
			const promoCodeField = $("#promocode");
			const promoCode = promoCodeField.val().trim();
			const message = $("#promoMessage");
			// let $this = $(this);
			// Check if the field is valid
			if (promoCodeField.valid()) {
				let storeUuid = $('#storeUuidInput').val();
				$.ajax({
					type: 'POST',
					url: SHOP_API.checkValidPromocode(storeUuid),
					data: { promocode: promoCode },
					beforeSend: toggleLoader,
					complete: toggleLoader,
					success: function (resultData) {
						// if (resultData.status == true) {
						// 	updateCartItem(resultData.products);
						// 	notify(i18n.t('shop.item_added_to_basket'));
						// }
						location.reload();
						// // Add a custom validation rule dynamically
						// promoCodeField.rules("add", {
						// 	equalTo: promoCode, // Custom rule
						// 	messages: {
						// 		equalTo: "This promo code is already used.",
						// 	},
						// });
					},
					error: function (jqXHR, error, errorThrown) {
						$('.promocode_wrapper').addClass('d-none');
						let jsonValue = jQuery.parseJSON( jqXHR.responseText );
						let errorMsg = jsonValue.message;
						$('.promocode-fieldset').addClass('has-error');
						message.text(errorMsg);
					}
				});
			}
		});

		$(".remove-promocode").click(function (e) {
			Swal.fire({
				title: i18n.t('shop.messages.are_you_sure'),
				text: i18n.t('shop.messages.remove_promo_from_cart'),
				icon: 'warning',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				allowOutsideClick: () => !Swal.isLoading(),
				confirmButtonText: i18n.t('front_pages.yes'),
				cancelButtonText: i18n.t('front_pages.no')
			}).then((willDelete) => {
				if (willDelete.value) {
					$.ajax({
						type: 'DELETE',
						url: SHOP_API.removeValidPromocode,
						beforeSend: toggleLoader,
						complete: toggleLoader,
						success: function (resultData) {					
							location.reload();
						},
						error: function (jqXHR, error, errorThrown) {
							// let jsonValue = jQuery.parseJSON( jqXHR.responseText );
							// let errorMsg = jsonValue.message;
							// $('.promocode-fieldset').addClass('has-error');
							// message.text(errorMsg);
						}
					});
				}
			});
		});

	}

	return {
		init: function () {
			viewProductDetails();
			viewServiceDetails();
			showShopDetails();
			// viewCart();
			addModifierToCart();
			addToCart();
			removeCart();
			removeProduct();
			trackOrderFormValidator();
			// pickupForm();
			cartProductFormValidator();
			cartFormValidator();
			pickupFormValidator();
			deliveryFormValidator();
			hideShowMyCart();
			openShoppingModal();
			select2CountryInit();
			select2Init();
			getDistrict();
			otpModule();
			applyPromocode();
			validateDeliveryTime();
		}
	};
}();

$(document).ready(function () {
	
	$('input[name="collection"]').on('change', function () {
		$('.radio_block').removeClass('active');
		$(this).closest('.radio_block').addClass('active');
		var selectedType = $('input[name="collection"]:checked').attr('id');
        let collection = 'pick-up';
		if (selectedType === 'pickup-my-order') {
			// $('.pick-up-form').removeClass('d-none');
			// $('.deliver-up-form').addClass('d-none');
            collection = 'pick_up';
		} else if (selectedType === 'deliver-to-me') {
			// $('.pick-up-form').addClass('d-none');
			// $('.deliver-up-form').removeClass('d-none');
            collection = 'deliver';
		}
        updateQueryStringParameter('collection', collection);
	});

    function updateQueryStringParameter(key, value) {
        var url = window.location.href; // Get current URL

        // Check if the key already exists in the URL
        var regex = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = url.indexOf('?') !== -1 ? "&" : "?";

        if (url.match(regex)) {
            // If the key exists, replace the old value with the new one
            url = url.replace(regex, '$1' + key + "=" + value + '$2');
        } else {
            // If the key doesn't exist, add it to the URL
            url = url + separator + key + "=" + value;
        }

        // Update the URL and reload the page
        window.location.href = url;
    }

	$(".phone-iti").each(function () {
		var phoneNumber = $('.phone-iti');
		var iti = window.intlTelInput(phoneNumber[0], {
			initialCountry: "auto",
			geoIpLookup: function geoIpLookup(callback) {
				$.getJSON('https://ipinfo.io?token=<your_token>', function (data) {
					callback(data.country);
				}).fail(function () {
					callback('sa');
				});
			},
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"
		});
	});

    // // Add onchange event listener
    // phoneNumber.on("countrychange", function() {
    //     const countryData = iti.getSelectedCountryData();
    //     const dialCode = '+'+countryData.dialCode;
    //     $("#countryCode").val(dialCode);
    // });

	$('.people-shop').removeClass('d-none');

	window.toggleMenu = function () {
		$("#store-banner-menu").fadeToggle();
	};

	$(".selectable-option").on("click", function (e) {
		$(".selectable-option").removeClass("selectable-option--active");
		$(this).addClass("selectable-option--active");
	});

	// $("#thank-you-modal").on('hide.bs.modal', function(){
	// 	alert('The modal is about to be hidden.');
	// });

	$('#deliver-to-me').on("click", function (e) {
		$("#collection-type").val("deliver");
	});

	$('#pickup-my-order').on("click", function (e) {
		$("#collection-type").val("pick-up");
	});

	$('#submit-collection-type').on("click", function (e) {
		// $('#collection-type-form').submit();
		$('#cartProductForm').submit();
	});

	$('#uploaderButton').click(function(){
		$("#uploader-input").click();
	});

	$('#uploader-input').change(function(e) {
		var fileName = e.target.files[0].name;
		$('#uploaded-file-name').text(fileName);
		$('.order-information__uploaderFileName').toggleClass('d-none');
	});

	$('input[type="tel"]').keypress(function (e) {
		var charCode = (e.which) ? e.which : event.keyCode;
		if (String.fromCharCode(charCode).match(/[^0-9]/g))
			return false;
	});

    $("#call-phone").on("click", function(){
        let phone = $(this).attr('data-phone');
        window.location.href = phone; // Replace with your URL
    });

    $("#whatsapp-phone").on("click", function(){
        let phone = $(this).attr('data-whatsapp');
        window.location.href = phone; // Replace with your URL
    });

    $('.open_more_tabs').on('click', function () {
        $(this).hide();
        $('.hidden_tab').show();
    });

    // var tabs = $('.tab_item');
    // tabs.on('click', function () {
    //     tabs.removeClass('active');
    //     $(this).addClass('active');
    //     var target = $(this).data('target');
    //     $('#' + target + '-content').addClass('show active');
    //     $('#' + target + '-content-header').addClass('active');
    //     let url = $(this).data('url');
    //     window.location.href = url;
    // });

	$('.category_footer button').on('click', function() {
        const $categoryBlock = $(this).closest('.category_block');
        $categoryBlock.find('.category_body').toggleClass('loadMore');
        $(this).closest('.category_footer').toggleClass('loadMore');
    });

	$('.valid-inputs').on('keypress', function(event) {
		var regex = new RegExp("^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$");
		var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
		if (!regex.test(key)) {
			event.preventDefault();
			return false;
		}
	});

	$('.map_button').on('click', function() {
        $('#check-delivery').toggleClass('d-none');
    });

	if (window.innerWidth <= 800) { // Example threshold for mobile view
		$('.product-category_footer').each(function() {
			let productCount = $(this).data('product-count');
			if (productCount > 1) {
				$(this).removeClass('d-none');	
			}
		});
	}

	$('.showScheduleDeliveryBlock').on('click', function() {
		var $container = $(this).closest('.deliver_content');
		if (!$container.length) {
			$container = $(this).closest('.pick_up_content');
		}
		if (!$container.length) return;
		var $scheduleBlock = $container.find('.scheduleDeliveryBlock');
		var $scheduleText = $container.find('.scheduleDeliveryText');
		var $scheduleTimeText = $container.find('.scheduleDeliveryTimimgText');
		if (this.checked) {
			$scheduleText.hide();
			$scheduleTimeText.fadeIn(300).css('display', 'block');
			$scheduleBlock.css('display', 'flex').hide().fadeIn(300);
		} else {
			$('#selectDeliveryDate').val('');
			$('#selectDeliveryTime').val('');
			$(".scheduleDeliveryTimimgText").html('');
			$scheduleBlock.fadeOut(300, function () {
				$scheduleTimeText.hide();
				$scheduleText.fadeIn(300).css('display', 'block');
			});
		}
	});

	var checkboxes = $('.custom-checkbox input');
	checkboxes.each(function () {
		var checkbox = $(this);
		var updateCheckboxState = function updateCheckboxState() {
			var parent = checkbox.parent();
			var isChecked = checkbox.is(':checked');
			parent.find('.unchecked').css('display', isChecked ? 'none' : 'block');
			parent.find('.checked').css('display', isChecked ? 'block' : 'none');
		};
		checkbox.on('change', updateCheckboxState);
		updateCheckboxState();
	});

	const searchInput = $("#menu_search-input");
	if (searchInput.val()) {
		$('#toggle-search-bar').removeClass('toggle-search-bar');
	}
	
	$('#toggle-search-bar').on('mouseenter', function(){
		$(this).removeClass('toggle-search-bar');
	});

	$('#toggle-search-bar').on('mouseleave', function(){
		if (searchInput.val() === "") {
			$(this).addClass('toggle-search-bar');
		} else {
			searchInput.focus();
		}
	});

	var sections = $('.category_block');
	var menuItems = $('.tabs_list .tab_item');
	const dynamicColor = $('#store-color').data('color');//"#38761d";

	// Scroll to category section on menu click
    $('.tab_item').on('click', function() {
        const categoryId = $(this).data('target');
        let targetOffset = $('#' + categoryId).offset().top;
		if (targetOffset < 0) {
			targetOffset = 0;
		} 

		menuItems.removeClass('active');
		menuItems.css({ 'background-color' : '', 'color' : dynamicColor });
		$('.tabs_list .tab_item[data-target="' + categoryId + '"]').addClass('active');
		$('.tabs_list .tab_item[data-target="' + categoryId + '"]').css({ 'background-color' : dynamicColor, 'color' : '' });

        $('html, body').animate({
            scrollTop: targetOffset - 100 // adjust offset for sticky menu if any
        }, 500);
    });

	// $('div#menu-tabContent').on('scroll', function () {
	// 	let scrollPos = $(window).scrollTop();
		
	// 	sections.each(function() {
	// 		let sectionTop = $(this).offset().top - 250; // Adjust offset as needed
	// 		let sectionBottom = sectionTop + $(this).outerHeight();
	// 		let currentCategory = $(this).attr('id');

	// 		if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
	// 			menuItems.removeClass('active');
	// 			menuItems.css({ 'background-color' : '', 'color' : dynamicColor });
	// 			$('.tabs_list .tab_item[data-target="' + currentCategory + '"]').addClass('active');
	// 			$('.tabs_list .tab_item[data-target="' + currentCategory + '"]').css({ 'background-color' : dynamicColor, 'color' : '' });
	// 		}
	// 	});

	// });

	shops.init();
	
});

var counter = 0;

window.notify = function (msg, type='success') {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
	counter = counter++;
	var marginBottom = 100;
	$(".t-toast").each(function () {
		marginBottom += 60;
	});
	if (type == 'error') {
		$("body").prepend("\n      <div class=\"t-toast\" style='background-color: #D75050; bottom:".concat(marginBottom, "px' id='toast-").concat(counter, "' >\n          <span class=\"t-toast__icon\">\n              <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <rect width=\"16\" height=\"16\" rx=\"8\" fill=\"white\"/>\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.69642 12.5117C7.12587 13.0822 6.2001 13.0822 5.62983 12.5117L2.42791 9.30978C1.85736 8.73951 1.85736 7.81374 2.42791 7.24346C2.99819 6.67291 3.92396 6.67291 4.49451 7.24346L6.40222 9.1509C6.54623 9.29464 6.78001 9.29464 6.9243 9.1509L12.0898 3.98538C12.6601 3.41483 13.5859 3.41483 14.1564 3.98538C14.4304 4.25936 14.5843 4.6311 14.5843 5.01854C14.5843 5.40597 14.4304 5.77771 14.1564 6.0517L7.69642 12.5117Z\" fill=\"#D75050\"/>\n              </svg>\n          </span>\n          <span class=\"t-toast__text\" >\n              ").concat(msg, "\n          </span>\n      <div>\n  "));
	} else {
		$("body").prepend("\n      <div class=\"t-toast\" style='bottom:".concat(marginBottom, "px' id='toast-").concat(counter, "' >\n          <span class=\"t-toast__icon\">\n              <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                  <rect width=\"16\" height=\"16\" rx=\"8\" fill=\"white\"/>\n                  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.69642 12.5117C7.12587 13.0822 6.2001 13.0822 5.62983 12.5117L2.42791 9.30978C1.85736 8.73951 1.85736 7.81374 2.42791 7.24346C2.99819 6.67291 3.92396 6.67291 4.49451 7.24346L6.40222 9.1509C6.54623 9.29464 6.78001 9.29464 6.9243 9.1509L12.0898 3.98538C12.6601 3.41483 13.5859 3.41483 14.1564 3.98538C14.4304 4.25936 14.5843 4.6311 14.5843 5.01854C14.5843 5.40597 14.4304 5.77771 14.1564 6.0517L7.69642 12.5117Z\" fill=\"#0BBF94\"/>\n              </svg>\n          </span>\n          <span class=\"t-toast__text\" >\n              ").concat(msg, "\n          </span>\n      <div>\n  "));
	}

	setTimeout(function () {
		$("#toast-".concat(counter)).fadeOut().remove();
	}, 2000);
};
"use strict";
